import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface ImproveReplyTurn {
	text: string
	// The docs run this message started; its group row is the run's result.
	groupId: string
	startedAt: number
}

interface ImproveReplySession {
	messageId: string
	turns: ImproveReplyTurn[]
}

const MAX_SESSIONS = 50
const NO_TURNS: ImproveReplyTurn[] = []

interface ImproveReplyTurnsState {
	// What someone asked the docs agent from the Improve reply panel, per agent
	// reply. Kept out of the panel so closing it or reloading keeps the run.
	sessions: ImproveReplySession[]
	addTurn: (messageId: string, turn: ImproveReplyTurn) => void
}

export const useImproveReplyTurnsState = create<ImproveReplyTurnsState>()(
	persist(
		(set, get) => ({
			sessions: [],
			addTurn: (messageId, turn) => {
				const sessions = get().sessions
				const current = sessions.find((s) => s.messageId === messageId)
				const next = [
					...sessions.filter((s) => s.messageId !== messageId),
					{ messageId, turns: [...(current?.turns ?? []), turn] },
				]
				set({
					sessions:
						next.length > MAX_SESSIONS
							? next.slice(next.length - MAX_SESSIONS)
							: next,
				})
			},
		}),
		{ name: "improve-reply-turns-state" },
	),
)

export const useImproveReplyTurns = (messageId: string) =>
	useImproveReplyTurnsState(
		(s) =>
			s.sessions.find((session) => session.messageId === messageId)?.turns ??
			NO_TURNS,
	)
